import React from 'react';
import { ListChecks, ShieldCheck, Wallet, CalendarClock } from 'lucide-react';
import FadeIn from './FadeIn';

const features = [
  { icon: ListChecks, label: 'Smart grocery planning' },
  { icon: ShieldCheck, label: 'Great quality — freshness guaranteed' },
  { icon: Wallet, label: 'Wholesale prices always — no markups' },
  { icon: CalendarClock, label: 'Scheduled home delivery' },
];

export default function SolutionSection() {
  return (
    <section className="section-spacing">
      <div className="content-width-wide">
        <div className="flex flex-col md:flex-row-reverse gap-12 items-center">
          {/* Image */}
          <FadeIn direction="left" className="md:w-1/2">
            <img
              src="https://images.unsplash.com/photo-1573246123716-6b1782bfc499?auto=format&fit=crop&w=800&q=80"
              alt="Fresh groceries delivered"
              className="rounded-2xl shadow-lg w-full h-72 md:h-80 object-cover"
            />
          </FadeIn>

          {/* Content */}
          <div className="md:w-1/2">
            <FadeIn>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground tracking-tight">
                A Smarter Way To Procure Groceries
              </h2>
            </FadeIn>
            <FadeIn delay={0.1}>
              <p className="mt-4 text-muted-foreground text-lg leading-relaxed">
                One Click Essentials acts as your personal grocery procurement partner. We organize your list, source the products, and deliver everything to your doorstep.
              </p>
              <p className="mt-4 text-foreground font-medium text-lg">
                You simply send your grocery list — we handle the rest.
              </p>
            </FadeIn>

            <ul className="mt-10 space-y-5">
              {features.map(({ icon: Icon, label }, i) => (
                <FadeIn key={i} delay={0.15 + i * 0.08}>
                  <li className="flex items-center gap-4 text-foreground text-base md:text-lg">
                    <span className="flex items-center justify-center h-10 w-10 rounded-lg bg-secondary flex-shrink-0">
                      <Icon className="h-5 w-5 text-primary" strokeWidth={1.5} />
                    </span>
                    {label}
                  </li>
                </FadeIn>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
